export default __webpack_public_path__ + "static/media/safle-logo_small.b416d361.svg";